import FeathersHelper from "../../helpers/feathers";

export const get = id => FeathersHelper.get('modules', id);
export const find = payload => FeathersHelper.find('modules', payload);
export const create = payload => FeathersHelper.create('modules', payload);
export const patch = (id, payload, params = {}) => FeathersHelper.patch('modules', id, payload, params);
export const remove = (id, params = {}) => FeathersHelper.remove('modules', id, params);
